module.exports = __webpack_public_path__ + "static/media/hn.7e936f52.svg";